import React, { useEffect, useState } from 'react';

const SettingsPage = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchSettings = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/get-settings.php');
      const data = await res.json();
      setSettings(data.settings || {});
    } catch (err) {
      setError('Failed to load settings.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = e => setSettings({ ...settings, [e.target.name]: e.target.value });

  const handleSave = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const res = await fetch('/api/update-settings.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      if (!res.ok) throw new Error('Failed to update settings');
      setSuccess('Settings updated successfully!');
    } catch (err) {
      setError('Failed to update settings.');
    }
  };

  return (
    <div style={{ padding: 'var(--section-padding)' }}>
      <h2 style={{ color: 'var(--color-primary)', fontSize: '2rem', fontWeight: 700, marginBottom: '2rem' }}>Settings</h2>
      {loading ? (
        <div>Loading settings...</div>
      ) : error ? (
        <div style={{ color: 'var(--color-error)' }}>{error}</div>
      ) : (
        <form onSubmit={handleSave} style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', padding: '2rem', maxWidth: 480 }}>
          {Object.keys(settings).length === 0 ? (
            <div style={{ color: 'var(--color-text-light)' }}>No settings found.</div>
          ) : (
            Object.entries(settings).map(([key, value]) => (
              <div key={key} style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>{key}</label>
                <input name={key} type="text" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={value} onChange={handleChange} />
              </div>
            ))
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
            <button type="submit" style={{ background: 'var(--color-primary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Save</button>
          </div>
          {success && <div style={{ color: 'var(--color-success)', marginTop: '1rem' }}>{success}</div>}
        </form>
      )}
    </div>
  );
};

export default SettingsPage; 